import React, { ComponentType } from 'react'
import {
  Grid,
  Popup,
  Icon,
  Modal
} from 'semantic-ui-react'
import { addDays } from 'date-fns'
// Local
import If from '../../common/if'
import PdfHuddleReport from '../../common/pdfHuddleReport'
import PrinterIcon from '../../icons/Printer/PrinterIcon'
import { DatePickerIcon } from '../../common/datePickerIcon'
import { Encounter } from '../../authenticated/types'
import { shouldRenderReskin2025 } from '../../../constant'

const SafeGrid = Grid as unknown as ComponentType<any>

type Props = {
  encountersState: Encounter[]
  fetchEncounters: (
    viewDate: Date,
    practitionerId: string,
    offset: number
  ) => void
  viewDateState: Date
  practitionerIDState: string
}

function PhysicianRightSubHeader(
  props: Props
): JSX.Element {
  const {
    encountersState,
    fetchEncounters,
    practitionerIDState,
    viewDateState
  } = props
  const changeDay = (newDate: Date) => {
    const offset = 0
    fetchEncounters(
      newDate,
      practitionerIDState,
      offset
    )
  }
  const incrementViewDate = () => {
    changeDay(addDays(viewDateState, 1))
  }
  const decrementViewDate = () => {
    changeDay(addDays(viewDateState, -1))
  }
  const onDateSelect = (value: Date) => {
    changeDay(value)
  }
  const encounterIds = encountersState.map(item => item.id)
  if (shouldRenderReskin2025) {
    return (
      <div className="reveleer-right-sub-header">
        <span onClick={ decrementViewDate }>
          <Popup
            content="Previous Day"
            mouseEnterDelay={ 1000 }
            trigger={
              <Icon
                name="arrow alternate circle left outline"
                size="large"
                color="grey"
                className="pointer"
              />
            }
          />
        </span>
        <span>
          <DatePickerIcon
            onSelect={ onDateSelect }
            popperClassName="datePickerIcon-popper-left-adjust"
          />
        </span>
        <span onClick={ incrementViewDate }>
          <Popup
            content="Next Day"
            mouseEnterDelay={ 1000 }
            trigger={
              <Icon
                name="arrow alternate circle right outline"
                size="large"
                color="grey"
                className="pointer"
              />
            }
          />
        </span>
        <If isTrue={ !!encounterIds.length }>
          <span>
            <Popup
              content="Daily Huddle PDF"
              mouseEnterDelay={ 1000 }
              trigger={
                <span className="print">
                  <Modal
                    size="fullscreen"
                    trigger={
                      <PrinterIcon />
                    }
                  >
                    <Modal.Content>
                      <PdfHuddleReport
                        startDt={ viewDateState }
                        practitionerId={ practitionerIDState }
                        region=""
                      />
                    </Modal.Content>
                  </Modal>
                </span>
              }
            />
          </span>
        </If>
      </div>
    )
  }
  return (
    <SafeGrid>
      <Grid.Row style={ { paddingBottom: '0rem' } }>
        <Grid.Column
          floated="right"
          align="right"
        >
          <span onClick={ decrementViewDate }>
            <Popup
              content="Previous Day"
              mouseEnterDelay={ 1000 }
              trigger={
                <Icon
                  name="arrow alternate circle left outline"
                  size="large"
                  color="grey"
                  className="pointer"
                />
              }
            />
          </span>
          <span>
            <DatePickerIcon
              onSelect={ onDateSelect }
              popperClassName="datePickerIcon-popper-left-adjust"
            />
          </span>
          <span onClick={ incrementViewDate }>
            <Popup
              content="Next Day"
              mouseEnterDelay={ 1000 }
              trigger={
                <Icon
                  name="arrow alternate circle right outline"
                  size="large"
                  color="grey"
                  className="pointer"
                />
              }
            />
          </span>
          <If isTrue={ encounterIds.length === 0 }>
            <span>
              <Icon
                size="large"
                className="empty"
              />
            </span>
          </If>
          <If isTrue={ !!encounterIds.length }>
            <span>
              <Popup
                content="Daily Huddle PDF"
                mouseEnterDelay={ 1000 }
                trigger={
                  <span>
                    <Modal
                      size="fullscreen"
                      trigger={
                        <PrinterIcon />
                      }
                    >
                      <Modal.Content>
                        <PdfHuddleReport
                          startDt={ viewDateState }
                          practitionerId={ practitionerIDState }
                          region=""
                        />
                      </Modal.Content>
                    </Modal>
                  </span>
                }
              />
            </span>
          </If>
        </Grid.Column>
      </Grid.Row>
    </SafeGrid>
  )
}

export default PhysicianRightSubHeader
